import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import tokenManager from "../utils/tokenManager";
import api from "../services/api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(tokenManager.getUser());
  const [license, setLicense] = useState(null);
  const [licenseLoading, setLicenseLoading] = useState(true);
  const [licenseError, setLicenseError] = useState(null);

  const refreshUser = useCallback(() => {
    setCurrentUser(tokenManager.getUser());
  }, []);

  const refreshLicense = useCallback(async () => {
    if (!tokenManager.isAuthenticated()) {
      setLicense(null);
      setLicenseLoading(false);
      return null;
    }
    try {
      setLicenseLoading(true);
      const res = await api.getLicenseSummary();
      setLicense(res);
      setLicenseError(null);
      return res;
    } catch (err) {
      console.error("Failed to load license summary:", err);
      setLicenseError(err);
      setLicense(null);
      return null;
    } finally {
      setLicenseLoading(false);
    }
  }, []);

  // Initial load + reload on user change
  useEffect(() => {
    refreshLicense();
  }, [currentUser?.id, refreshLicense]);

  useEffect(() => {
    const handleUserChange = () => {
      refreshUser();
      refreshLicense();
    };
    window.addEventListener("userChanged", handleUserChange);
    return () => window.removeEventListener("userChanged", handleUserChange);
  }, [refreshUser, refreshLicense]);

  return (
    <UserContext.Provider
      value={{
        currentUser,
        refreshUser,
        license,
        licenseLoading,
        licenseError,
        refreshLicense,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
